import React, { useContext, useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import {useCookies} from 'react-cookie';
import axios from 'axios';
import { base_url } from '../../url_variables';
import { TostMessageContext } from "../../context/TostMessage";
import ReactLoading from 'react-loading';
import { FaCalendarAlt, FaUser, FaSignOutAlt, FaCogs, FaSearch } from "react-icons/fa";
import { IoMdChatboxes } from "react-icons/io";
import { AiOutlineClockCircle } from "react-icons/ai";
import { HiOutlineBookOpen } from "react-icons/hi";
import { MdOutlineDashboard, MdLanguage } from "react-icons/md";
import { SideMenu } from '../../components/sidebar';
import { TopBar } from '../../components/topbar';
import {ButtonBlack, ButtonSmall} from '../../components/buttons';
import { RouteDisplay } from '../../components/route_display';
import { UserContext } from '../../context/UserContext';
import { ScheduleGroupClassModal } from '../../components/schedule_group_class';
import User from '../../images/user.jpg';
import { IoLibraryOutline } from 'react-icons/io5';
import ProgressBarComponent from '../../components/progess_bar'
import { ClockLoader } from 'react-spinners';
import { ScheduleClassModal } from '../../components/schedule_class_modal'

function AssignedClassesScreen() {
    const navigate = useNavigate();
    const [cookies] = useCookies();
    const [loadingClasses, setLoadingClasses] = useState(true);
    const [enrolledClasses, setEnrolledClasses] = useState([]);
    const { setTostMessage } = useContext(TostMessageContext);
    const [showGroupScheduleModal, setShowGroupScheduleModal] = useState(false)
    const {logOutFunction, calendarValues, setCalendarValues, userProfile} = useContext(UserContext);
    const [profileData, setProfileData] = useState({ 'f_name': '', 'l_name': '', 'm_name': '', 'streak': '', 'dob': '', 'classes': [], 'attendance': 0 });
    const [groupScheduleDetails, setGroupScheduleDetails] = useState({});
    const [showScheduleModal, setShowScheduleModal] = useState(false);
    const [paymentModalDetails, setPaymentModalDetails] = useState({});


    useEffect(() => {
        getClasses();
    }, [])

    const getClasses = async () => {
        setLoadingClasses(true);
        try {
            const response = await axios.get(base_url + '/classes/fetch-assigned.php', {
                headers: {
                    "Content-Type": "multipart/form-data",
                    token: cookies?.userProfile?.session,
                    main_id: cookies?.userProfile?.main_id,
                    sub_id: cookies?.userProfile?.sub_id
                },
            });
            if (response.data.code == 403) {
                setLoadingClasses(false);
                setTostMessage({
                    messageType: "error",
                    message: response.data.response,
                });
                logOutFunction()
            }
            if (response.data.status) {
                setLoadingClasses(false);
                setEnrolledClasses(response.data.results);
            } else {
                setLoadingClasses(false);
                setTostMessage({
                    messageType: "error",
                    message: response.data.response,
                });
            }
        } catch (error) {
            setLoadingClasses(false);
            setTostMessage({
                messageType: "error",
                message: 'Network error',
            });
        }
    }

  return (
    <div className="relative h-screen h-full">
        <div className="flex h-screen bg-white">
            {/* Sidebar */}
            <SideMenu />
            {/* Main content */}
            <main className="flex-1 p-8 overflow-y-auto">
                {/* Header */}
                <TopBar />
                <RouteDisplay />
                <div className='w-full flex flex-row justify-between'>
                    {showGroupScheduleModal && (
                        <ScheduleGroupClassModal 
                            group_id={groupScheduleDetails?.group_id} 
                            language_name={groupScheduleDetails?.language_name}
                            level_name={groupScheduleDetails?.level_name}
                            sessions_array={groupScheduleDetails?.sessions_array}
                            loading={false} 
                            setShowGroupScheduleModal={setShowGroupScheduleModal}
                        />
                    )}
                    {showScheduleModal && (
                        <ScheduleClassModal 
                            subscription_id={paymentModalDetails?.subscription_id} 
                            language_name={paymentModalDetails?.language_name}
                            level_name={paymentModalDetails?.level_name}
                            no_of_sessions={paymentModalDetails?.no_of_sessions}
                            tutor_avail={paymentModalDetails?.tutor_avail}
                            sessions_array={paymentModalDetails?.sessions_array}
                            loading={false} 
                            setShowScheduleModal={setShowScheduleModal}
                        />
                    )}
                    {loadingClasses ? (
                        <div className='flex justify-center items-center w-fill-available h-full z-[999999] bg-[#ffffff] opacity-[0.6] fixed top-0'>
                            <ClockLoader
                                color={'#F4D00F'}
                                loading={loadingClasses}
                                size={60}
                                aria-label="Loading Spinner"
                                data-testid="loader1"
                            />
                        </div>
                    ) : (
                    <div className="w-full lg:w-[100%] p-0 lg:p-6 space-y-6 min-h-screen">
                        <h2 className="text-xl font-semibold mb-6">Assigned Classes</h2>
                        <div className='overflow-x-auto'>
                            <table className="w-full table-auto border-collapse text-sm">
                                <thead className="bg-gray-50 border-b">
                                <tr>
                                    <th className="p-4">
                                        <div className="flex items-center gap-1">#</div>
                                    </th>
                                    <th className="text-left px-4 py-2 font-medium text-gray-600">
                                        <div className="flex items-center gap-1">Class</div>
                                    </th>
                                    <th className="text-left px-2 py-2 font-medium text-gray-600">
                                        <div className="flex items-center gap-1">Student(s)</div>
                                    </th>
                                    <th className="text-left px-2 py-2 font-medium text-gray-600">
                                        <div className="flex items-center gap-1">Age Group</div>
                                    </th>
                                    <th className="text-left px-4 py-2 font-medium text-gray-600">
                                        <div className="flex items-center gap-1">Category (Sessions)</div>
                                    </th>
                                    <th className="text-left px-4 py-2 font-medium text-gray-600">
                                        <div className="flex items-center gap-1">Period</div>
                                    </th>
                                    <th className="text-left px-2 py-2 font-medium text-gray-600">
                                        <div className="flex items-center gap-1">Action</div>
                                    </th>
                                </tr>
                                </thead>
                                <tbody className="text-gray-700">
                                    {enrolledClasses?.map((row, index) => (
                                        <tr
                                        key={index}
                                        className={index % 2 === 0 ? "bg-white" : "bg-gray-50"}
                                        >
                                            <td className="px-4 py-2">
                                                {++index}
                                            </td>
                                            <td className="px-4 py-2 font-semibold">
                                                {row.language} ({row.level_name})
                                            </td>
                                            <td className="px-2 py-2">
                                                {row.category == "GROUP" ? row.max_no : row.child_name}
                                            </td>
                                            <td className="px-2 py-2">
                                                {row.category == "GROUP" ? row.age_group + ' years' : 'N/A' }
                                            </td>
                                            <td className="px-4 py-2">
                                                {row.category} #{row.group_id} ({row.no_of_classes} left)
                                            </td>
                                            <td className="px-4 py-2">
                                                {row.category == "GROUP" ? row.start_date + ' -> ' + row.end_date : 'N/A'}
                                            </td>
                                            <td className="px-2 py-2">
                                                <button onClick={() => navigate('/assigned-classes/tasks', {state: { language: row.language, level_name: row.level_name, students: row.students_in_class, group_id: row.group_id, subscription_id: row.sub_id, category: row.category }})} className='px-4 py-2 bg-yellow m-1 rounded-[5px] text-dark'>Manage Tasks</button>
                                                {(row.category == "GROUP" && row.no_of_classes < 1) && 
                                                    <button onClick={() => {setGroupScheduleDetails({level_name: row.level_name, language_name: row.language, group_id: row.group_id, sessions_array: row.sessions_array}); setShowGroupScheduleModal(true)}} className='px-4 py-2 bg-[#12B2FF] rounded-[5px] text-white m-1 cursor-pointer'>Schedule</button>
                                                }
                                                {(row.category == "GROUP" && row.no_of_classes > 1) && 
                                                    <button className='px-4 py-2 bg-[#12B2FF] cursor-not-allowed opacity-[0.7] rounded-[5px] text-white m-1 cursor-pointer'>Schedule</button>
                                                }
                                                {(row.category == "PRIVATE") && 
                                                    <button onClick={() => {setPaymentModalDetails({level_name: row.level, language_name: row.language, no_of_sessions: row.no_of_sessions, subscription_id: row.sub_id, tutor_avail: row.tutor_avail, sessions_array: row.sessions_array}); setShowScheduleModal(true)}} className='px-4 py-2 bg-[#12B2FF] rounded-[5px] text-white m-1 cursor-pointer'>Schedule</button>
                                                }
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                    )}
                </div>
            </main>
        </div>
    </div>
  );
}

export default AssignedClassesScreen;
